import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { ConfigurationInsurerCreateRequest, ConfigurationInsurerPatchInBatchRequest, ConfigurationInsurerResponse } from '@/modules/configurationModule/detail/cases/insurers/services/configuration-insurer.dto'

class ConfigurationInsurerService {
    async create(request: ConfigurationInsurerCreateRequest): Promise<ConfigurationInsurerResponse> {
        const response = await axios.post<ConfigurationInsurerResponse>(`/configuration/insurers`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined): Promise<IResponseAgGrid<ConfigurationInsurerResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationInsurerResponse>>(`/configuration/insurers`, { ...filterModel }, { params })
        return response.data
    }

    async get(insurerId: number): Promise<ConfigurationInsurerResponse> {
        const response = await axios.get<ConfigurationInsurerResponse>(`/configuration/insurers/${insurerId}`)
        return response.data
    }

    async delete(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/insurers/batch`, { data: request })
        return response.data
    }

    async patch(request: ConfigurationInsurerPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/insurers/batch`, request)
        return response.data
    }
}

export const configurationInsurerService = new ConfigurationInsurerService()
